import { render } from "./ModalCreditCard.vue?vue&type=template&id=3b9d48f4&scoped=true"
import script from "./ModalCreditCard.vue?vue&type=script&lang=js"
export * from "./ModalCreditCard.vue?vue&type=script&lang=js"

import "./ModalCreditCard.vue?vue&type=style&index=0&id=3b9d48f4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9d48f4"]])

export default __exports__